// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__33mse","title":"AfterFrontImage_title__1d35W"};